import styles from './ListLoadError.module.css';

/**
 * Shown when a list could NOT be loaded.
 *
 * Why this exists: every admin list previously rendered its EMPTY state on a failed
 * fetch, because the catch block only raised a transient toast and left the array at
 * `[]`. Once the toast expired, a broken backend was indistinguishable from a genuinely
 * empty list. This component is the error state those lists were missing.
 */
const ListLoadError = ({ message = 'Could not load this list', onRetry }) => (
  <div className={styles.container} role="alert">
    <svg
      className={styles.icon}
      width="40"
      height="40"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="13" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
    <h3 className={styles.title}>{message}</h3>
    <p className={styles.hint}>
      The data could not be loaded, so nothing is shown here. This is not the same as
      having no records — check your connection and try again.
    </p>
    {onRetry && (
      <button type="button" className={styles.retry} onClick={onRetry}>
        Try again
      </button>
    )}
  </div>
);

export default ListLoadError;
